export abstract class SkeletonComponentBase {
  public errorThrown = false;
  public errorMessage = '';
  public showBanner = true;

  /**
   * Set the error configuration to show after error occurred.
   * @param errorMsg
   * @param showBanner
   */
  protected setError(showBanner = true, errorMsg = ''): void {
    this.errorThrown = true;
    this.errorMessage = errorMsg;
    this.showBanner = showBanner;
  }
}
